// ********************************************************
//
// IMPORT
//
// ********************************************************
import VConsole from 'vconsole'

import FontService from '@/services/FontService'
//import WechatService from '@/services/WechatService'
import AssetService from '@/services/AssetService'
import MediaService from '@/services/MediaService'
import SoundService from '@/services/SoundService'
import '@/services/ResizeService'
import '@/services/AnalyticsService'
import '@/helpers/Raf'

import fontManifest from '@/config/fonts'
import assetManifest from '@/config/asset'
import mediaManifest from '@/config/media'
import soundManifest from '@/config/sound'

import store from '@/store'

// ********************************************************
//
// DOCUMENT
//
// ********************************************************
const loadDocument = function() {
  return new Promise((resolve) => {
    const onReady = function() {
      setTimeout(resolve, 1)
    }

    if (document.readyState === 'complete') {
      onReady()
    } else {
      document.onreadystatechange = () => {
        if (document.readyState === 'complete') {
          onReady()
        }
      }
    }
  })
}

// ********************************************************
//
// APP
//
// ********************************************************
async function initApp() {
  await loadDocument()

  console.group('Initialization')

  store.commit('app/setLoadStep', 'vconsole')
  if (store.state.app.vconsole) new VConsole()

  store.commit('app/setLoadStep', 'app')
  await import('./main')

  store.commit('app/setLoadStep', 'fonts')
  await FontService.load(fontManifest)

 // store.commit('app/setLoadStep', 'wechat')
  //await WechatService.init()

  store.commit('app/setLoadStep', 'media')
  await MediaService.load(mediaManifest)

  store.commit('app/setLoadStep', 'sound')
  await SoundService.load(soundManifest)

  store.commit('app/setLoadStep', 'assets')
  await AssetService.load(assetManifest)

  store.commit('app/setLoadStep', 'completed')
  store.commit('app/setLoadComplete')

  console.groupEnd()

  store.dispatch('app/getVersion')
}

// ********************************************************
//
// INIT
//
// ********************************************************
initApp()
